import React from 'react';
import { TicketCardContent, TicketCardFooter } from '../../../../detail/components/ticket-card/ticketCard';
import { useTranslation } from 'react-i18next';
import Rate from './Rate';
import Session from './Session';
import Inventory from './Inventory';
import '../../../override.css';

export default function Rates({ form, timer }) {
    const { ticketsCount } = form;
    const { t } = useTranslation();
    const rowCount = form.inventories.length || form.sessions.length ? ticketsCount > 3 : ticketsCount >= 7;
    const [style, setStyle] = React.useState(false);

    let renderComponent = React.useMemo(() => {
        if (form.use_sessions) {
            return form.sessions.map(session => {
                let selected_rates = form.selected_rates.filter(selected_rate => selected_rate.rate.sessionId === session.value);
                return <Session key={session.id} session={session} form={form} rates={selected_rates} />;
            });
        }
        if (form.inventories.length) {
            return form.inventories.map(inventory => {
                let selected_rates = form.selected_rates.filter(s_rate => s_rate.inventory === inventory);
                return <Inventory key={inventory.id} inventory={inventory} rates={selected_rates} form={form} />;
            });
        }

        return form.selected_rates.map(rate => {
            return <Rate key={rate.rate.pk} rate={rate} quantity={rate.quantity} totalAmount={form.totalAmount} currency={form.currency} form={form} />;
        });
    }, [form]);

    if (form.use_sessions && !form.selected_rates.length) {
        return null;
    }

    return (
        <>
            <TicketCardContent className={`order-summary-content ${style === true ? 'summary-body-extended' : 'summary-body'}`}>
                {timer}
                {renderComponent}
            </TicketCardContent>

            {rowCount && (
                <TicketCardFooter>
                    <div className="order-summary-toggle-dropdown" onClick={() => setStyle(!style)}>
                        {style ? t('ticket.common.seeLessDetails') : t('ticket.common.seeMoreDetails')}
                    </div>
                </TicketCardFooter>
            )}
        </>
    );
}
